import { Typography, Box, Paper } from "@mui/material";
import {
  QuillR2Editor,
  QUILL_MODULES,
  QUILL_FORMATS,
} from "../../../utils/quillQuestionEditorConfig";

const ShortAnswerEditor = ({ value, onChange, showMathTools }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: "#444" }}>
      Correct Answer
    </Typography>
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        background: "#fafafa",
        "& .ql-container": { minHeight: 80, fontSize: "0.95rem" },
      }}
    >
      <QuillR2Editor
        value={value || ""}
        onChange={onChange}
        modules={QUILL_MODULES}
        formats={QUILL_FORMATS}
        placeholder="Enter the correct answer..."
        showMathTools={showMathTools}
      />
    </Paper>
  </Box>
);

export default ShortAnswerEditor;
